import React from 'react';
import { withRouter } from 'react-router-dom';

import classes from './TitleBar.css';
import Arrow from '../Arrow/Arrow';
import canadaLogo from '../../../assets/images/canada.svg';
import usaLogo from '../../../assets/images/usa.svg';
import HambergerBtn from '../HambergerBtn/HambergerBtn';
import translation from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

const titleBar = props => {
  const {
    clicked,
    title,
    country,
    sideMenuTriggered,
    sideMenuHandler,
    language,
    wideHeading
  } = props;

  return (
    <header className={classes.TitleBar}>
      <div className={classes.BackBtnWrapper}>
        <div
          className={classes.BackButton}
          onClick={clicked}
          onKeyDown={clicked}
        >
          <Arrow direction="back" />
          <span style={wideHeading ? { fontSize: '2vh' } : null}>{translation[language].back}</span>
        </div>
      </div>
      <h1 style={wideHeading ? { fontSize: '2vh' } : null}>{title}</h1>
      {country === 'Canada' ? (
        <img src={canadaLogo} alt="canada-logo" />
      ) : (
        <img src={usaLogo} alt="usa-logo" />
      )}
      <HambergerBtn
        sideMenuTriggered={sideMenuTriggered}
        sideMenuHandler={sideMenuHandler}
      />
    </header>
  );
};

export default withRouter(titleBar);
